// AgentPool — projected by Portal::AgentPools::Presenter.
// Named group of CompanyUsers referenced by EscalationPolicy via
// assignee_agent_pool_id.

export type DefaultableRole = "admin" | "agent_manager" | "agent"

export const DEFAULTABLE_ROLES: DefaultableRole[] = ["admin", "agent_manager", "agent"]

export type AgentPool = {
  id: number
  name: string
  description: string | null
  defaultForRoles: DefaultableRole[]
  memberCount: number
  memberIds: number[]            // company_user ids
  usedByPolicyCount: number
  createdAt: string
}

export type AgentPoolMember = {
  companyUserId: number
  name: string
  email: string
  avatarUrl: string | null
  role: string
}

export type AgentPoolsIndexProps = {
  pools: AgentPool[]
  members: AgentPoolMember[]
  // NOT named `capabilities` — that's the global string[] from
  // inertia_share consumed by useCan(). See presenter.rb for the why.
  poolCapabilities: { canEdit: boolean }
}

export type CreatePoolBody = {
  name: string
  description?: string
  default_for_roles?: DefaultableRole[]
  company_user_ids?: number[]
}

export type UpdatePoolBody = Partial<{
  name: string
  description: string
  default_for_roles: DefaultableRole[]
  company_user_ids: number[]
}>
